import { render, staticRenderFns } from "./BriefFolderRenameModal.vue?vue&type=template&id=339a15fa"
import script from "./BriefFolderRenameModal.vue?vue&type=script&lang=js"
export * from "./BriefFolderRenameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339a15fa')) {
      api.createRecord('339a15fa', component.options)
    } else {
      api.reload('339a15fa', component.options)
    }
    module.hot.accept("./BriefFolderRenameModal.vue?vue&type=template&id=339a15fa", function () {
      api.rerender('339a15fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/BriefFolderRenameModal.vue"
export default component.exports